import { connect } from 'react-redux';

import Unauthorized from 'components/app/unauthorized-component';

const mapStateToProps = ({ data: { currentUser } }) => ({
  currentUser,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Unauthorized);
